import types from '../mutation-types';
import ConversationApi from '../../api/inbox/conversation';

const state = {
  allCount: 0,
};

export const getters = {
  getStats: $state => $state,
};

export const actions = {
  set({ commit }, meta) {
    commit(types.SET_CONV_TAB_META_MENTION, meta);
  },
};

export const mutations = {
  [types.SET_CONV_TAB_META_MENTION]($state, { all_count: allCount } = {}) {
    $state.allCount = allCount;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
